import { useCallback } from "react";

import { DatatableRowData } from "../datatable-types";
import { useDatatableContext } from "../use-datatable-context";

export const useColumnDisplayValue = <TData extends DatatableRowData>() => {
  const { getConfigurationForColumn } = useDatatableContext<TData>();

  return useCallback(
    (columnId: string): string => getConfigurationForColumn(columnId)?.getDisplayValue() ?? "",
    [getConfigurationForColumn],
  );
};
